import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { SubscriptionState } from './state';

const defaultState: SubscriptionState = {
  periods: [],
  packages: [],
  subscriptionsInfo: {
    current: null,
    history: [],
  },
};

export const subscriptionModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
